
import {AddressDetails} from './address-details';

export class PropertyDetails extends AddressDetails {
planNumber:string;
lotNumber:string;
InstallationNumber:string 
nearestCrossStreet:string
xCoordinate:number
yCoordinate:number
}


// WEBPACK FOOTER //
// ./src/app/shared/data-objects/property-details.ts